<!-- eslint-disable no-console -->
<template>
    <gat-form>
       <gat-group title="Import csv file" :collapsed="false">
          <v-layout wrap>
            <input v-show="false" type="file" name="inputfile" id="inputfile" @change="fileSelectedForUpload">              
            <v-btn flat @click="selectFile">Select file</v-btn>          
             <!-- <gat-select
                v-model="importFileId"
                :items="importFiles"
                label="Import file"
                textFieldName="FILENAME"
                codeFieldName="ID"/> -->
            
             <!-- <v-btn flat :disabled="!importFileId" @click="loadFileData(importFileId)">Load file data</v-btn> -->
             <v-btn flat :disabled="!mappedData || mappedData.length === 0" @click="saveTransactionsClicked">Import as transactions</v-btn>                  
             <gat-edit v-model="invoiceDate" :dateEdit="true" label="Transaction date" size="s" @input="invoiceDateChanged" :clearable="true" />                      
          </v-layout>
          <div >
            <v-divider></v-divider>
            <v-tabs v-model="tab">
               <v-tab key="tab-mapped">Mapped data</v-tab>
               <v-tab key="tab-struct">Structured data</v-tab>
               <v-tab key="tab-mapping">Mapping</v-tab>
               <v-tab key="tab-csv">CSV data</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
               <v-tab-item key="tab-mapped">
                  <mapped-data-view :mappedData="mappedData" :mappingName="selectedMapping.name" :existingTransactions="LastImportedTransactions" />
               </v-tab-item>
               <v-tab-item key="tab-struct">
                  <struct-data-view :parsedData="parsedData" />
               </v-tab-item>
               <v-tab-item key="tab-mapping">
                  <data-mapping-view :parsedData="parsedData" :csvData="csvData" @mapping-changed="mappingChanged" />
               </v-tab-item>
               <v-tab-item key="tab-csv">
                  <v-btn flat @click="parseFileData(csvData)">Parse</v-btn>
                  <gat-edit v-model="csvData" size="xs12" label="CSV data" rows="10" id="field_csvData" />
               </v-tab-item>
            </v-tabs-items>    
         </div>                    
       </gat-group>
    </gat-form>
 </template>
 
 <script lang="ts">
 import Vue from "vue";
 import GatGroup from "../../../GatComponents/GatGroup.vue";
 import GatEdit from "../../../GatComponents/GatEdit.vue";
 import GatForm from "../../../GatComponents/GatForm.vue";
 
 import { apiGet } from "../../../dal";
//  import GatSelect from "../../../GatComponents/GatSelect.vue";
 import { parseCsvData } from "../helpers/DataParser";
 import StructDataView from "./StructDataView.vue";
 import DataMappingView from "./DataMappingView.vue";
 import { mapStrutureDataToTransactionModel } from "../helpers/DataMapper";
 import MappedDataView from "./MappedDataView.vue";
 import { transformData } from "../helpers/DataTransformer";

 
 export default Vue.extend({
    name: "FileImporterView",
    components: { GatGroup, GatEdit, GatForm,  StructDataView, DataMappingView, MappedDataView },
    props: {LastImportedTransactions: Array},
    data() {
       return {
          importFiles: [],
          importFileId: "",
          invoiceDate: null,
          csvData: "",
          selectedAmount: 0,
          parsedData: {},
          mappedData: [],
          selectedMapping: {},
          tab: null,
       };
    },
 
    activated() {},
 
    mounted() {       
       this.invoiceDate = new Date();
    },
 
    deactivated() {},
 
    computed: {
       gridColumns() {
          const columns = [
             { header: "Import", field: "doImport" },
             { header: "Date", field: "transDate" },
             { header: "Amount", field: "amount" },
             { header: "Supplier", field: "supplier" },
             { header: "Category", field: "category" },
             { header: "Notes", field: "notes" },
             { header: "Card", field: "cardName" },
          ];
          return columns;
       },
    },
 
    methods: {
       loadFileData(fileId) {
          apiGet("import/file/" + fileId).then((response) => {
             if (response != null && response.length > 0) {
                this.csvData = response[0].FILE_CONTENT;
                this.parseFileData(this.csvData);               
             }
          });
       },

       fileSelectedForUpload(event) {
          var file = event.target.files[0];
          var reader = new FileReader();
          reader.onload = (e) => {
             var data = e.target.result;             
             this.csvData = data;
             this.parseFileData(this.csvData);       
          };
          reader.readAsText(file);
       },
 
       mappingChanged(mapping) {
          this.selectedMapping = mapping;
          this.tryMapData();
       },

       invoiceDateChanged() {         
          this.tryMapData();
       },
 
       saveTransactionsClicked(){
         //send event with selectedData
         this.$emit("save-transactions", this.mappedData.filter(x => x.doImport));
       },
 
       tryMapData() {
          if (this.selectedMapping && this.parsedData && this.parsedData.data) {
            var transformedData = transformData(this.parsedData.data,this.selectedMapping.transformers);
             this.mappedData = mapStrutureDataToTransactionModel(transformedData, this.selectedMapping, this.invoiceDate);      
          } else {
             this.mappedData = [];
          }
       },
  
       parseFileData(data) {
          var structData = parseCsvData(data);                  
          this.parsedData = structData;
          this.tryMapData();
       },

       selectFile() {
          document.getElementById('inputfile').click();
       },     
    },
 });
 </script>
 
 <style scoped>
 .gridCheckbox {
    margin-top: 12px;
    margin-bottom: -12px;
 }
 
 #field_csvData {
    max-height: 1000px;
    overflow-y: auto;
 }
 
 .compactMapView {
    max-height: 700px;
    overflow-y: auto;
 }
 </style>
 